<!--其它出库  -->
<template>
	<div class="info-box">
		<el-dialog title="装车单信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="1000px" :before-close="cancle"
			top="3vh">
			<div>
						<div class="info-title">基本信息:</div>
						<!--  -->
						<div class="mt5 flex flex-wrap">
								<div class=" nc-box">
									<span class="info-name"> 单号: </span>
									<span class="ml15"> {{rowData.loadCode||'无'}}</span>
							    </div>
								<div class=" nc-box">
									<span class="info-name"> 计划日期: </span>
									<span class="ml15"> {{rowData.planDate||'无'}}</span>
							    </div>
								<div class=" nc-box">
									<span class="info-name"> 路线: </span>
									<span class="ml15"> {{rowData.routeName||'无'}}</span>
							    </div>
								<div class=" nc-box">
									<span class="info-name"> 巡回计划: </span>
									<span class="ml15"> {{rowData.planCode||'无'}}</span>
							    </div>
								<div class=" nc-box">
									<span class="info-name"> 主路线员: </span>
									<span class="ml15"> {{rowData.mainUserName||'无'}}</span>
							    </div>
								<div class=" nc-box">
									<span class="info-name"> 副路线员: </span>
									<span class="ml15"> {{rowData.secUserName||'无'}}</span>
							    </div>
								<div class=" nc-box" v-for="(item,key,index) in rowData.sumList" :key="index">
									<span class="info-name"> {{key}}: </span>
									<span class="ml15"> {{item||'无'}}</span>
							    </div>
								<div class=" nc-box" v-for="(item,key,index1) in rowData.drinkList" :key="key+index1">
									<span class="info-name"> {{key}}: </span>
									<span class="ml15"> {{item||'无'}}</span>
							    </div>
							
								<div class="nc-box">
									<span class="info-name"> 制单员: </span>
									<span class="ml15"> {{rowData.createdName||'无'}}</span>
							    </div>
								<!-- 均衡线 -->
								<div class="nc-box" v-if="(Object.keys(rowData.sumList||{}).length+Object.keys(rowData.drinkList||{}).length)%2!=1">
							    </div>
							
							<!--  -->
						</div>

					</div>
				<!--  -->
					<!-- 配送客商情况 -->
			
				<div class="info-title mt20">装车明细:</div>
				<el-table class="mt20" :data="loadList" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					 border style="width: 100%">
					 <el-table-column prop="loadType" label="装车类型">
						 <template slot-scope="scope">
							<span v-if="scope.row.loadType==0">出库</span>
							<span v-else-if="scope.row.loadType==1">试饮</span>
							<span v-else>回库</span>
						 </template>
					 </el-table-column>
					 <el-table-column prop="skuName" label="SKU"></el-table-column>
					 <el-table-column prop="productQuantity" label="数量"></el-table-column>
					 <el-table-column prop="storeName" label="出货仓"></el-table-column>
					 <el-table-column prop="productDate" label="生产日期"></el-table-column>
				</el-table>
			<div class="info-title mt20">回库明细:</div>
				<el-table class="mt20" :data="backList" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					 border style="width: 100%">
					 <el-table-column prop="skuName" label="SKU"></el-table-column>
					 <el-table-column prop="productQuantity" label="数量"></el-table-column>
					 <el-table-column prop="storeName" label="出货仓"></el-table-column>
					 <el-table-column prop="productDate" label="生产日期"></el-table-column>
				</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
			</span>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
import {dateTimeFormat} from '@/utils/common'
	export default {
		components: {
			
		},
		data() {
			return {
				dialogVisible: false,
				dateTimeFormat:null,
				ruleForm:{
					loadId: "",
				},
				rowData: {},
				loadList: [],
				backList: [],
			}
		},
		created() {
			this.dateTimeFormat = dateTimeFormat
		},
		methods: {
			init(data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.rowData = {}
					this.pageNo = 1
					this.ruleForm = {
						loadId: "",
					}
					if (data) {
						this.ruleForm.loadId = data.dataKey
						this.getInfo()
					}

				})

			},
			// 查询
			getInfo() {
				let that = this;
				that.$request.post(
						"loadVehicleInfo",
						true, {
							loadId: that.ruleForm.loadId,
						}
					)
					.then((res) => {
						if (res) {
							that.backList = res.data.backList
							that.loadList = res.data.loadList
							that.rowData = res.data
						}
					}).catch((err)=>{
						console.warn(err)
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.w90 {
		width: 110px;
	}

	.nc-box {
		padding: 10px 0;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
		width: 50%;
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.w190 {
		width: 280px !important;
	}

	.info-box {
		/deep/ .el-dialog__body {
			// height: 330px;
			overflow-y: auto;
			padding: 20px 20px 10px;
		}
	}

	.info-title {
		background: #E5E5E5;
		color: #333;
		padding: 10px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;

		img {
			vertical-align: bottom;
			display: block;
		}
	}

	.el-form-item {
		width: 420px;
	}

	.w330 {
		width: 330px;
	}

	.w420 {
		width: 420px !important;
		margin-right: 10px;
	}

	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
	}

	.opeartion {
		font-size: 18px;
	}

	.lh30 {
		line-height: 30px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

</style>
